// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 94 ? "pdfjsWorker" : chunkId) + "." + {"94":"f1581214","404":"e34f1d8d","513":"450d8a5d","787":"230876f5"}[chunkId] + ".chunk.js";
};